import * as React from "react"

const TwitterIcon = (props) => (
  <svg
    width={18}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.137 4.594a7.818 7.818 0 0 0 1.828-1.899 6.918 6.918 0 0 1-2.11.563 3.607 3.607 0 0 0 1.618-2.04 7.798 7.798 0 0 1-2.32.915 3.691 3.691 0 0 0-2.708-1.16 3.69 3.69 0 0 0-3.691 3.691c0 .281.035.563.105.844A10.71 10.71 0 0 1 1.23 1.64a3.59 3.59 0 0 0-.492 1.863c0 1.266.633 2.39 1.653 3.058-.598-.035-1.196-.175-1.688-.457v.036a3.696 3.696 0 0 0 2.953 3.62c-.281.071-.633.141-.949.141-.246 0-.457-.035-.703-.07.457 1.477 1.828 2.531 3.445 2.566A7.422 7.422 0 0 1 .88 13.98c-.317 0-.598-.035-.879-.07 1.617 1.055 3.55 1.652 5.66 1.652 6.785 0 10.477-5.59 10.477-10.476v-.492Z"
      fill="#4952E3"
    />
  </svg>
)

export default TwitterIcon
